/**
 * Formats a plain integer count with UK locale thousands separators
 * (comma, no decimals), e.g. `1234567` -> `"1,234,567"`, `42` -> `"42"`.
 *
 * Use for any whole-number count rendered in UI prose, a table cell or a
 * length-cap message: tokens, rows, people, messages, characters. For a
 * monetary minor-units amount with no symbol, use
 * `formatMinorUnitsWithSeparators`.
 */
export function formatCount(value) {
    return value.toLocaleString('en-GB');
}
